var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationMarkerTransavia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BB8DB5C1-5D2A-4A13-B820-CF555D6945FB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transavia",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transavia/Desktop/Destination",
    transform: "translate(-32.000000, -106.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter/Bestemming",
    transform: "translate(0.000000, 23.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Formfield/Dropdown/Default",
    transform: "translate(16.000000, 45.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Large/Rome",
    transform: "translate(16.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C4.95,0 2.5,2.45 2.5,5.5 C2.5,6.7 3.1,8 3.65,9 C5.75,12.45 8,16 8,16 C8,16 10.25,12.45 12.35,9 C12.95,8.05 13.5,6.75 13.5,5.5 C13.5,2.45 11.05,0 8,0 Z M8,8.1 C6.6,8.1 5.4,6.95 5.4,5.5 C5.4,4.05 6.55,2.9 8,2.9 C9.45,2.9 10.6,4.05 10.6,5.5 C10.6,6.95 9.4,8.1 8,8.1 Z",
    id: "Shape",
    fill: "#2800A0"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarkerTransavia);
export default __webpack_public_path__ + "static/media/location-marker-transavia.0789fe46ac2845610aaa9422b3948086.svg";
export { ForwardRef as ReactComponent };